// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_listener.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for handling global keyboard event listeners,
//     allowing customizable key sequences and associated actions.
// </summary>
// ***********************************************************************

window.listener = window.listener || {};

/**
 * Adds a global keyboard event listener for a specified key sequence and triggers
 * a specified callback function when the sequence is detected.
 *
 * @function add
 * @memberof window.listener
 * @param {string} keySequence - The key sequence to listen for (e.g., 'ctrl+k').
 * @param {string} methodPath - The global method path to call when the key sequence is detected (e.g., 'window.dialog.showNavbarSearchModal').
 * @param {any} methodParam - The parameter to pass to the method when it is called.
 */
window.listener.add = function(keySequence, methodPath, methodParam) {
    const keys = keySequence.split('+');
    const ctrlRequired = keys.includes('ctrl');
    const altRequired = keys.includes('alt');
    const shiftRequired = keys.includes('shift');
    const keyRequired = keys.find(k => !['ctrl', 'alt', 'shift'].includes(k));

    document.addEventListener('keydown', function(event) {
        const ctrlPressed = event.ctrlKey;
        const altPressed = event.altKey;
        const shiftPressed = event.shiftKey;
        const keyPressed = event.key.toLowerCase();

        if (ctrlRequired === ctrlPressed &&
            altRequired === altPressed &&
            shiftRequired === shiftPressed &&
            keyRequired === keyPressed) {
            event.preventDefault();

            const method = new Function('return ' + methodPath)();
            if (typeof method === 'function') {
                method(methodParam);
            }
        }
    });
};

/**
 * Removes the global keyboard event listener for a specified key sequence.
 *
 * @function remove
 * @memberof window.listener
 * @param {string} keySequence - The key sequence to stop listening for (e.g., 'ctrl+k').
 */
window.listener.remove = function(keySequence) {
    const handler = window.listener.handlers[keySequence];
    if (handler) {
        document.removeEventListener('keydown', handler);
        delete window.listener.handlers[keySequence];
    }
};